<template>
	<div class="w-100">
		<div class="w-100 text-center py-3 mb-4 radius-8" style="background-color: #ffe7d4 !important;">
			<p class="body-2-1 mb-1">Payment expired in</p>
			<p class="heading-4-1 mb-0" v-if="timeout">00:00:00</p>
			<p v-else class="heading-4-1 mb-0">
				<template v-if="countdown.hours() < 10">
					0{{countdown.hours()}}:
				</template>
				<template v-else>
					{{countdown.hours()}}:
				</template>
				<template v-if="countdown.minutes() < 10">
					0{{countdown.minutes()}}:
				</template>
				<template v-else>
					{{countdown.minutes()}}:
				</template>
				<template v-if="countdown.seconds() < 10">
					0{{countdown.seconds()}}
				</template>
				<template v-else>
					{{countdown.seconds()}}
				</template>
			</p>
		</div>
		<div class="p-3 radius-8 border-semi-grey mb-4" ref="qris_wrap">
			<div class="row">
				<div class="col-6 align-self-center">
					<img height="26" src="../../../assets/img/icon/payment/qris-square.png">
				</div>
				<div class="col-6 align-self-center text-right">
					<img height="42" src="../../../assets/img/icon/payment/gnp.png">
				</div>
				<div class="col-12 mt-4 text-center">
					<p class="mb-0 body-1-4">{{getMerchant.name}}</p>
				</div>
				<div class="col-8 offset-2 text-center">
					<img :src="payment.qr_image" class="w-100">
				</div>
				<div class="col-12 my-3">
					<div class="w-100 border-b-semi-grey-dashed">
					</div>
				</div>
				<div class="col-6 align-self-center">
					<p class="mb-0 body-1-4">Total Payment</p>
				</div>
				<div class="col-6 align-self-center text-right">
					<p class="mb-0 body-1-4 text-green">{{$formatCurrency(payment.total_bill)}}</p>
				</div>
			</div>
		</div>
		<div class="d-table mx-auto my-4">
			<state-button :click="captureAndDownload" variant="secondary-outline" size="md">Download QR</state-button>
		</div>
	</div>
</template>
<script type="text/javascript">
	import moment from 'moment'
	import {mapGetters} from 'vuex'
	import html2canvas from 'html2canvas';

	export default{
		props:{
			data:{
				type: Object
			},
			module_page:{
				type: String,
				default: 'RESTAURANT'
			},
			customer_detail:{
				type: Object,
				default: () => {}
			}
		},
		data(){
			return{
				countdown: moment(),
	      timeout: false,
	      payment: {}
			}
		},
		computed:{
			...mapGetters(['getMerchant'])
		},
		mounted(){
			this.setupData().then(()=>{
				this.setupCountdown()
			})
		},
		methods:{
			setupCountdown(){
				let now = moment().format("YYYY-MM-DD HH:mm:ss")
				let exp = null

				if(this.payment.pg_company == 'IPAYMU' || this.payment.pg_company == 'XENDIT'){
					let offset_time = "+07:00"
					let exp_date = moment(this.payment.expired_date).format("HH:mm:ss")
					let local_tz = moment().format("Z")
					let exp_z = moment(`${exp_date}${offset_time}`,'HH:mm:ssZ').format()
		      exp = moment.parseZone(exp_z).local().format("YYYY-MM-DD HH:mm:ss")
				} else{
					now = this.payment.pg_company == 'JOKUL_DOKU' ? moment().add(1,'h').format("YYYY-MM-DD HH:mm:ss") : now
		      exp = moment(this.payment.expired_date_utc).format("YYYY-MM-DD HH:mm:ss")
				}

	      this.countdown = moment.duration(moment(exp).diff(moment(now)))

	      let looping = setInterval(() => {
	          this.countdown = this.countdown.subtract(1, 'seconds')
	        if (this.countdown.hours() <= 0 && this.countdown.minutes() <= 0 && this.countdown.seconds() <= 0) {
	          clearInterval(looping)
	          this.timeout = true
	        }
	      },1000)
			},
			setupData(){
				return new Promise(done=>{
					if(this.module_page == 'RESTAURANT'){
						this.payment = {
							pg_company: this.data.payment_channel.payment_gateway.pg_company,
							pm_name: this.data.payment_channel.name,
							pm_description: this.data.payment_channel.description,
							pm_image: this.data.payment_channel.image_url,
							qr_image: `data:image/png;base64,${this.data.payment_details.payment.qr_image}` ,
							payment_gateway_page: this.data.payment_channel.payment_gateway.pg_company == 'JOKUL_DOKU' ? this.data.payment_details.payment.how_to_pay_page : '',
							expired_date: this.data.payment_details.payment.expired_date,
							expired_date_utc: this.payment.pg_company == 'JOKUL_DOKU' ? this.data.payment_details.payment.expired_date_utc : '' ,
							total_bill: this.data.tx_bill_payment.total_paid
						}
					}else if(this.module_page == 'HOTEL_UPSELLING'){
						this.payment = {
							pg_company: this.data.payment_channel.bank_name,
							pm_name: this.data.payment_channel.name,
							pm_description: this.data.payment_channel.description,
							pm_image: this.data.payment_channel.image_url,
							qr_image: this.data.payment_details.ch_ref1 ,
							expired_date: "",
							expired_date_utc: "",
							total_bill: this.data.total_paid
						}
						if(this.data.payment_channel.bank_name == 'DIRECT_PAYMENT'){
							this.payment.expired_date_utc = moment(this.data.created_at).add(this.data.payment_channel.payment_gateway.payment_validation_time,'h').utc().format()
							this.payment.expired_date = moment(this.payment.expired_date_utc).local().format()
						}else{
							this.payment.expired_date_utc = this.data.payment_details.expired_date_utc
							this.payment.expired_date = this.data.payment_details.expired_date
						}
					}else if(this.module_page == 'HOTEL_CONCIERGE' || this.module_page == 'HOTEL_RESERVATION'){
						let pg = this.data.payment_channel.payment_gateway
						let pg_res = this.module_page == 'HOTEL_CONCIERGE' ? JSON.parse(this.data.inq_resp_detail) : this.data.inq_resp_detail
						this.payment = {
							pg_company: pg.pg_company,
							pm_name: this.data.payment_channel.name,
							pm_description: this.data.payment_channel.description,
							pm_image: this.data.payment_channel.image_url,
							qr_image: this.data.payment_channel.ch_ref1 ,
							expired_date: "",
							expired_date_utc: "",
							total_bill: this.data.total_paid
						}
						if(pg.pg_company == 'DIRECT_PAYMENT'){
							this.payment.expired_date_utc = moment(this.data.created_at).add(this.data.payment_channel.payment_gateway.payment_validation_time,'h').utc().format()
							let exp_date = moment(this.data.created_at).add(this.data.payment_channel.payment_gateway.payment_validation_time,'h').format()
							this.payment.expired_date = exp_date
						}else{
							this.payment.expired_date_utc = pg_res.payment.expired_date_utc
							this.payment.expired_date = pg_res.payment.expired_date
							this.payment.qr_image = `data:image/png;base64,${pg_res.payment.qr_image}`
						}
					}else if(this.module_page == 'TICKET'){
						this.payment = {
							pg_company: this.data.payment_channel.bank_name,
							pm_name: this.data.payment_channel.name,
							pm_description: this.data.payment_channel.description,
							pm_image: this.data.payment_channel.image_url,
							qr_image: `data:image/png;base64,${this.data.payment_details.qr_image}` ,
							payment_gateway_page: '',
							expired_date: this.data.payment_details.expired_date,
							expired_date_utc: '' ,
							total_bill: Number(this.data.total_payment)+Number(this.data.payment_surcharge)
						}
					}
					done()
				})
			},
			captureAndDownload(){
      	return new Promise((success,fail)=>{
					let file_name = `${this.getMerchant.name} - QRIS Payment.png`
					this.$domToImg(this.$refs.qris_wrap, file_name).finally(()=>{
						success()
					})
      	})
      }
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/general/payment/Qris.vue